import { IEventEventType, EventEventType } from "./eventEventType";
import { IEventHandler, EventHandler } from "./eventHandler";
import { Base } from "ui/Scripts/source/framework/base";
import { IEventMessage, EventMessage } from "./eventMessage";

export interface IFirstApproveAndClosedDate {
    firstApprovedDate: number;
    closedDate: number;
}

export interface IEventEditItem {
    id: string;
    companyId: string;
    createCompanyId: string;
    unitId: string;
    unitCode: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    urgencyClassId: string;
    code: string;
    name: string;
    date: number;
    description: string;
    observer: string;
    observerAction: string;
    immediateAction: string;
    preventiveAction: string;
    rootCause: string;
    directCosts: number;
    indirectCosts: number;
    amount: number;
    identificationDetails: string;
    latitude: number;
    longitude: number;
    locationName: string;
    publishDate: number;
    publishUserCode: string;
    publishUserName: string;
    publishUserPicture: string;
    createDate: number;
    createUserCode: string;
    createUserName: string;
    createUserPicture: string;
    modifyDate: number;
    modifyUserCode: string;
    modifyUserName: string;
    modifyUserPicture: string;
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;
    isRead: boolean;
    rowId: string;
    eventTypes: IEventEventType[];
    eventHandlers: IEventHandler[];
    eventMessages: IEventMessage[];

    isNew(): boolean;
    isPublished(): boolean;
    getFirstAndLastEventHandlerApproveDate(): IFirstApproveAndClosedDate;
}

export class EventEditItem implements IEventEditItem {
    id: string;
    companyId: string;
    createCompanyId: string;
    unitId: string;
    unitCode: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    urgencyClassId: string;
    code: string;
    name: string;
    date: number;
    description: string;
    observer: string;
    observerAction: string;
    immediateAction: string;
    preventiveAction: string;
    rootCause: string;
    directCosts: number;
    indirectCosts: number;
    amount: number;
    identificationDetails: string;
    latitude: number;
    longitude: number;
    locationName: string;
    publishDate: number;
    publishUserCode: string;
    publishUserName: string;
    publishUserPicture: string;
    createDate: number;
    createUserCode: string;
    createUserName: string;
    createUserPicture: string;
    modifyDate: number;
    modifyUserCode: string;
    modifyUserName: string;
    modifyUserPicture: string;
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;
    isRead: boolean;
    rowId: string;
    eventTypes: EventEventType[];
    eventHandlers: EventHandler[];
    eventMessages: EventMessage[];

    constructor();
    constructor(obj: IEventEditItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.createCompanyId = obj && obj.createCompanyId || "";
        this.unitId = obj && obj.unitId || "";
        this.unitCode = obj && obj.unitCode || "";
        this.createCompanyUnitId = obj && obj.createCompanyUnitId || "";
        this.createCompanyUnitCode = obj && obj.createCompanyUnitCode || "";
        this.urgencyClassId = obj && obj.urgencyClassId || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.date = obj && obj.date || 0;
        this.description = obj && obj.description || "";
        this.observer = obj && obj.observer || "";
        this.observerAction = obj && obj.observerAction || "";
        this.immediateAction = obj && obj.immediateAction || "";
        this.preventiveAction = obj && obj.preventiveAction || "";
        this.rootCause = obj && obj.rootCause || "";
        this.directCosts = obj && obj.directCosts || 0;
        this.indirectCosts = obj && obj.indirectCosts || 0;
        this.amount = obj && obj.amount || 0;
        this.identificationDetails = obj && obj.identificationDetails || "";
        this.latitude = obj && obj.latitude || null;
        this.longitude = obj && obj.longitude || null;
        this.locationName = obj && obj.locationName || "";
        this.publishDate = obj && obj.publishDate || null;
        this.publishUserCode = obj && obj.publishUserCode || "";
        this.publishUserName = obj && obj.publishUserName || "";
        this.publishUserPicture = obj && obj.publishUserPicture || "";
        this.createDate = obj && obj.createDate || 0;
        this.createUserCode = obj && obj.createUserCode || "";
        this.createUserName = obj && obj.createUserName || "";
        this.createUserPicture = obj && obj.createUserPicture || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.modifyUserCode = obj && obj.modifyUserCode || "";
        this.modifyUserName = obj && obj.modifyUserName || "";
        this.modifyUserPicture = obj && obj.modifyUserPicture || "";
        this.lockedDate = obj && obj.lockedDate || null;
        this.lockedUserCode = obj && obj.lockedUserCode || "";
        this.lockedUserName = obj && obj.lockedUserName || "";
        this.lockedUserPicture = obj && obj.lockedUserPicture || "";
        this.isRead = obj && obj.isRead || false;
        this.rowId = obj && obj.rowId || "";
        this.eventTypes = Base.getTypedArray<EventEventType>(obj ? obj.eventTypes : null, EventEventType);
        this.eventHandlers = Base.getTypedArray<EventHandler>(obj ? obj.eventHandlers : null, EventHandler);
        this.eventMessages = Base.getTypedArray<EventMessage>(obj ? obj.eventMessages : null, EventMessage);
    }

    isNew(): boolean {
        return Base.isNullOrEmpty(this.rowId);
    }
        
    isPublished(): boolean {
        return !!this.publishDate;
    }

    getFirstAndLastEventHandlerApproveDate(): IFirstApproveAndClosedDate {
        const result: IFirstApproveAndClosedDate = {
            firstApprovedDate: null,
            closedDate: null
        };
        if (this.eventHandlers.length < 1) return result;
        let allApproved = true;
        for (let i = 0; i < this.eventHandlers.length; i++) {
            const approveDate = this.eventHandlers[i].approveDate;
            if (Base.isNullOrUndefined(approveDate)) {
                result.closedDate = null;
                allApproved = false;
                continue;
            }
            if (Base.isNullOrUndefined(result.firstApprovedDate) || result.firstApprovedDate > approveDate) {
                result.firstApprovedDate = approveDate;
            }
            if (allApproved && (Base.isNullOrUndefined(result.closedDate) || result.closedDate < approveDate)) {
                result.closedDate = approveDate;
            }
        }
        return result;
    }
}